// extracted by css-extract-rspack-plugin
export default {"CommentBox":"IssueCommentEditor-module__CommentBox__iKARz","EditorMarginContainer":"IssueCommentEditor-module__EditorMarginContainer__LDnGi"};